// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__HtgIi","container":"footer_container__u4zri","logo":"footer_logo__ukBYM"};